<app-breadcrumbs title="Data Exchange" type="parent"></app-breadcrumbs>

@if (!userType) {
  <div>
    <kehe-phoenix-loading></kehe-phoenix-loading>
  </div>
} @else {
  <div class="container">
    @if (userType === "broker") {
      <app-esn-subscriptions></app-esn-subscriptions>
    } @else if (userType === "supplier") {
      <app-subscriptions></app-subscriptions>
    }
  </div>
}
